var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Outline_24 / Heart-white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9362 11.4102C1.51274 7.92308 3.74046 4 7.19334 4C9.12359 4 10.6891 4.87179 12 6.61538L12.1652 6.40198C13.442 4.80066 14.9568 4 16.8067 4C20.2595 4 22.4873 7.92308 21.0638 11.4102C20.4702 12.8644 19.1152 14.6204 16.9989 16.6782C15.7333 17.9088 14.1938 19.2131 13.1604 20.0629C12.4839 20.6192 11.5161 20.6192 10.8396 20.0629C9.80625 19.2131 8.26666 17.9088 7.00109 16.6782C4.88476 14.6204 3.5298 12.8644 2.9362 11.4102Z",
    fill: "black",
    fillOpacity: 0.2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWhite);
export default __webpack_public_path__ + "static/media/heart-white.e7f1ed51dfbe48a915a88bfaf4713354.svg";
export { ForwardRef as ReactComponent };